export default function auth({ next, store }) {

    if (!store.getters['authentification/auth'].status.loggedIn) {
        return next({
            name: 'Login'
        })
    }

    return next()
}